import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

// --- EGYEDI SVG IKONOK (AZ APP XML-JEI ALAPJÁN) ---
const IconHome = ({ size = 25, color = "#b30000" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M10,20v-6h4v6h5v-8h3L12,3 2,12h3v8z"/>
  </svg>
);

const IconTraining = ({ size = 25, color = "#b30000" }) => (
  <svg width={size} height={size} viewBox="0 0 300 300" fill={color}>
    <path d="M117.2,33.2c-1.9,1.9 -1.4,3.9 1.5,7 2.4,2.5 2.5,2.9 1.1,4.5 -0.8,1 -3.4,4.9 -5.8,8.8 -2.4,3.8 -7.9,12.6 -12.2,19.4l-7.8,12.4 0,-5.3c0,-20 -24.4,-30 -39.3,-16.1 -9.9,9.1 -9.7,26.1 0.5,34.6 7.5,6.3 18,7.7 25.6,3.5 2.5,-1.4 3.9,-2.7 3.3,-3.3 -0.5,-0.5 0.4,-2.8 2.3,-5.6 1.7,-2.7 3.6,-5.6 4.2,-6.6 1.1,-2 3.4,-1.3 3.4,1.1 0,1.8 -7,12.4 -8.1,12.4 -0.5,-0 -2.5,2.2 -4.5,5l-3.6,5 -20.1,-0c-22.6,-0 -25.8,0.8 -31,6.9 -2.2,2.6 -2.7,4.3 -2.7,8.4 0,10 5.8,15.1 16.7,15.1l6.3,-0 0,20.1c0,19.9 -2.2,41.6 -8.5,83.8 -1.5,10 -1.3,13.5 1.2,17.4 1.8,2.7 7.2,5.3 11,5.3 3.4,-0 8.8,-3.1 10.3,-5.9 0.6,-1.2 3.3,-13.2 6.1,-26.8 2.7,-13.7 5.1,-25.2 5.3,-25.7 0.1,-0.5 1,4.2 1.9,10.5 6.1,42.6 6,42.2 12,46 4.7,2.9 10.9,2.1 15.2,-2.1 1.8,-1.8 3.5,-4.4 3.8,-5.9 0.3,-1.4 0,-8.9 -0.8,-16.6 -1.5,-15.2 -4,-43.6 -5.1,-58 -0.4,-5.6 -0.3,-8.6 0.3,-8 1.8,1.9 20.3,32.1 20.3,33.1 0,0.6 -0.9,1.9 -2,2.9 -2.4,2.1 -2.6,4.8 -0.5,6.5 2.2,1.9 3.7,0.8 10.2,-7.2 13.2,-16.1 22.7,-33.5 27.3,-50.1 2.3,-8.2 5,-24.7 5,-30.7l0,-4 7.8,-0c5.7,0.1 7.2,0.3 6,1.1 -2.1,1.2 -2.4,4.5 -0.6,5.1 1.3,0.5 15.4,-5.7 17.5,-7.6 0.7,-0.6 0.9,-1.6 0.5,-2.2 -1,-1.7 -14.8,-8.4 -17.2,-8.4 -2.3,-0 -2.7,2.8 -0.7,4.9 1,1.1 0.9,1.3 -0.6,0.7 -1,-0.3 -4.5,-0.6 -7.8,-0.6l-5.9,-0 0,-3.6c0,-5.4 -3.7,-22.4 -6.6,-30.6 -5.7,-15.8 -17,-35.3 -26.9,-46.6 -4.8,-5.4 -6.2,-6.1 -8.3,-4zM130.5,55.9c10,15.2 18,35.6 20.9,53.8l1.3,8.3 -29.4,-0 -29.4,-0 -3.2,-3.3c-1.8,-1.9 -3.8,-3.6 -4.5,-3.8 -0.9,-0.3 3.5,-8 13.4,-23.4 8.1,-12.7 17,-26.7 19.7,-31.2 2.8,-4.5 5.4,-8 5.8,-7.7 0.4,0.2 2.8,3.5 5.4,7.3zM79,67.2c5.7,3.9 7.5,7.2 7.5,13.8 0,6.6 -1.8,9.9 -7.5,13.7 -6.7,4.6 -17.6,1.8 -22.2,-5.6 -4.6,-7.4 -1.5,-18.6 6.3,-22.4 5,-2.4 11.9,-2.2 15.9,0.5zM84.4,119.1c1.5,1.2 2.6,3 2.6,4.4 0,5.8 -8.2,7.9 -35.6,9.1 -14.3,0.6 -16.1,0.5 -17.7,-1 -4.2,-4.2 -3.1,-10.2 2.4,-12.9 2.8,-1.4 6.9,-1.7 24.5,-1.7 19.9,-0 21.3,0.1 23.8,2.1zM158,120.6c1.1,1.2 1,1.8 -0.4,3.2 -1.6,1.6 -1.8,1.6 -3.1,-0.2 -1.1,-1.4 -1.2,-2.3 -0.4,-3.3 1.5,-1.7 2.4,-1.6 3.9,0.3zM181.6,120.5c1.9,1.5 1.9,1.5 0,3 -2.5,1.9 -5,1.9 -6.6,-0 -3,-3.6 2.5,-6.2 6.6,-3zM153,128.5c0,1.9 -0.1,3.5 -0.2,3.5 -0.2,-0 -11.1,1.1 -24.3,2.5 -13.2,1.4 -26.3,2.5 -29.1,2.5 -6.5,-0 -7.7,1.4 -7.2,8 0.1,2.7 0.1,5 -0.2,4.9 -0.3,-0 -2,-3 -3.9,-6.7 -2.6,-5.1 -3,-6.7 -2,-7.1 2.6,-0.8 7.9,-6.9 7.9,-9 0,-2.1 0.2,-2.1 29.5,-2.1l29.5,-0 0,3.5zM81.5,143.1c1.4,2.7 4.4,7.9 6.5,11.5 4,6.4 4,6.5 4,16.9 0,9 2.8,44.4 5.9,74 0.8,7.2 0.7,9.4 -0.5,11.2 -1.9,3 -5,3.8 -7.9,1.9 -2.8,-1.8 -2.2,0.9 -8.1,-39.1 -2.6,-17.6 -5.1,-33 -5.6,-34.3 -0.9,-2.6 -4.6,-2.7 -5.9,-0.2 -0.4,0.8 -3.8,17.2 -7.6,36.4 -6.4,32.8 -7,35 -9.4,36.9 -2.1,1.5 -3.1,1.7 -4.8,0.8 -3.8,-2.1 -4,-4 -2,-18.6 7.8,-55.6 7.9,-56.2 7.9,-78.7l0,-21.6 8.8,-0.7c4.8,-0.3 9.4,-0.8 10.2,-0.9 5,-1.1 6,-0.6 8.5,4.5zM151.5,143.2c-3.2,19.2 -10.4,36.1 -22.9,53.6l-4.5,6.4 -1.7,-3.4c-0.9,-1.8 -6.5,-11 -12.4,-20.3l-10.7,-17 0.1,-9.1 0.1,-9.1 9.5,-0.7c7.4,-0.6 38.1,-3.8 42.3,-4.5 0.5,-0 0.6,1.8 0.2,4.1zM94.8,155.2l-0.3,2.3 -1.3,-2.3c-1.1,-1.9 -1.1,-2.6 0,-3.9 1.2,-1.5 1.3,-1.5 1.6,-0 0.2,0.9 0.2,2.7 0,3.9zM98.5,169c0.7,2.1 0,4 -1.6,4 -0.5,-0 -0.9,-1.4 -0.9,-3 0,-3.4 1.5,-4 2.5,-1zM74.6,201.5l0.6,6 -2.7,-0c-2.7,-0 -2.7,-0.1 -2.1,-5.2 1.2,-10.3 3.2,-10.6 4.2,-0.8z"/>
    <path d="M217.7,74.1c-15.1,3.5 -31.5,19.4 -35.2,34 -0.5,2.1 -0.1,2.7 2.9,4.2 3.4,1.6 3.6,1.6 3.6,-0.2 0,-1 1.6,-5 3.5,-8.8 4.3,-8.7 11.2,-15.3 20.3,-19.6 6.1,-2.9 7.6,-3.2 16.3,-3.2 8.9,-0 9.9,0.2 17,3.7 9.2,4.5 16,11.2 20.2,19.8 3,6.1 3.2,7 3.2,18 0,10.5 -0.2,12 -2.8,17.1 -7.9,16.1 -22.4,24.6 -40.1,23.7 -16.7,-0.9 -32,-12.4 -36.8,-27.6 -0.7,-2.3 -1.6,-4.2 -2.1,-4.2 -1.4,-0 -5.7,3.2 -5.7,4.2 0,2.8 6.7,14.4 11,19.2 9.9,10.8 21.1,15.6 36,15.6 19.4,-0 36.2,-10.4 44.1,-27.5 12.8,-27.3 -2.6,-60.4 -31.6,-68 -6.4,-1.6 -17.7,-1.8 -23.8,-0.4z"/>
    <path d="M222.5,92.9c-13.7,3.6 -22.8,15.2 -22.8,29.2 0,25.8 31.6,38.8 49.9,20.5 6,-6.1 8.4,-12.2 8.4,-21.5 -0.1,-11.1 -5.9,-20.4 -16.2,-25.7 -5.2,-2.6 -14.3,-3.8 -19.3,-2.5zM236.1,100.1c13.3,4 19.7,21 12.6,33.2 -5.1,8.6 -14.8,12.7 -24.8,10.6 -6.6,-1.4 -15.1,-9.2 -16.8,-15.4 -4.9,-17.8 11.3,-33.6 29,-28.4z"/>
    <path d="M221.8,113.9c-2.9,2.6 -3.3,3.5 -3.3,8.1 0,4.6 0.4,5.5 3.3,8.1 4.7,4.3 10.2,4.1 14.8,-0.5 2.8,-2.8 3.4,-4.2 3.4,-7.6 0,-3.4 -0.6,-4.8 -3.4,-7.6 -4.6,-4.6 -10.1,-4.8 -14.8,-0.5zM232,119c2.4,2.4 2.4,3 0.7,5.4 -0.9,1.2 -2.3,1.7 -4.2,1.4 -2.5,-0.2 -3.1,-0.8 -3.3,-3.3 -0.3,-1.9 0.2,-3.3 1.4,-4.2 2.4,-1.7 3,-1.7 5.4,0.7z"/>
  </svg>
);

const IconProfile = ({ size = 25, color = "#b30000" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12,2C6.48,2 2,6.48 2,12s4.48,10 10,10 10,-4.48 10,-10S17.52,2 12,2zM12,5c1.66,0 3,1.34 3,3s-1.34,3 -3,3 -3,-1.34 -3,-3 1.34,-3 3,-3zM12,19.2c-2.5,0 -4.71,-1.28 -6,-3.22 0.03,-1.99 4,-3.08 6,-3.08 1.99,0 5.97,1.09 6,3.08 -1.29,1.94 -3.5,3.22 -6,3.22z"/>
  </svg>
);

const IconMedal = ({ size = 25, color = "#b30000" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12,13L3,2h3l6,7 6,-7h3L12,13z"/>
    <path d="M12,13c-3.31,0 -6,2.69 -6,6s2.69,6 6,6 6,-2.69 6,-6 -2.69,-6 -6,-6zm0,10c-2.21,0 -4,-1.79 -4,-4s1.79,-4 4,-4 4,1.79 4,4 -1.79,4 -4,4z"/>
    <path d="M12,21l-2.31,1.21 0.44,-2.57 -1.87,-1.83 2.59,-0.38 1.16,-2.35 1.16,2.35 2.59,0.38 -1.87,1.83 0.44,2.57z"/>
  </svg>
);

const BottomNavbar = () => {
  const [activePopup, setActiveTab] = useState(null);
  const location = useLocation();
  const popupRef = useRef(null);

  // Bezárás külső kattintásra
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setActiveTab(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navItemStyle = (isActive) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    color: "#b30000",
    fontSize: '10px',
    fontWeight: 'bold',
    transition: '0.2s',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    opacity: 1
  });

  return (
    <div className="force-light-theme" style={navbarContainerStyle}>
      {/* 1. FŐOLDAL */}
      <Link to="/" style={navItemStyle(location.pathname === '/')} onClick={() => setActiveTab(null)}>
        <IconHome color="#b30000" />
        <span>FŐOLDAL</span>
      </Link>

      <div style={dividerStyle} />

      {/* 2. EDZÉS (KÖZVETLEN LINK) */}
      <div style={{ position: 'relative', flex: 1, display: 'flex', justifyContent: 'center' }}>
        <Link
          to="/edzeseim"
          style={navItemStyle(location.pathname === '/edzeseim')}
          onClick={() => {
            console.log("EDZÉS gomb megnyomva - Közvetlen link aktív");
            setActiveTab(null);
          }}
        >
          <IconTraining color="#b30000" />
          <span>EDZÉS</span>
        </Link>

        {/* INAKTÍV POPUP (Későbbi fejlesztéshez megőrizve) */}
        {false && activePopup === 'training' && (
          <div ref={popupRef} style={popupStyle}>
            <div style={popupItem} onClick={() => alert('Új párbaj indítása...')}>Új párbaj</div>
            <div style={popupItem} onClick={() => alert('Új edzés indítása...')}>Új edzés</div>
            <div style={popupItem} onClick={() => alert('Edzéseim megnyitása...')}>Edzéseim</div>
            <div style={arrowStyle} />
          </div>
        )}
      </div>

      <div style={dividerStyle} />

      {/* 3. PROFIL */}
      <Link to="/profil" style={navItemStyle(location.pathname === '/profil')} onClick={() => setActiveTab(null)}>
        <IconProfile color="#b30000" />
        <span>PROFIL</span>
      </Link>

      <div style={dividerStyle} />

      {/* 4. VERSENY (POPUP-PAL) */}
      <div style={{ position: 'relative', flex: 1, display: 'flex', justifyContent: 'center' }}>
        <button style={navItemStyle(activePopup === 'competition')} onClick={() => setActiveTab(activePopup === 'competition' ? null : 'competition')}>
          <IconMedal color="#b30000" />
          <span>VERSENY</span>
        </button>

        {activePopup === 'competition' && (() => {
          const savedSession = localStorage.getItem('competition_scoring_session');
          let hasActiveSession = false;

          if (savedSession) {
            const session = JSON.parse(savedSession);
            const now = Date.now();
            const diffInHours = (now - (session.lastUpdated || 0)) / (1000 * 60 * 60);

            if (diffInHours < 48) {
              hasActiveSession = true;
            } else {
              localStorage.removeItem('competition_scoring_session');
            }
          }

          return (
            <div ref={popupRef} style={popupStyleRight}>
              {hasActiveSession && (
                <>
                  <Link to="/competition-scoring-web" style={{ textDecoration: 'none' }} onClick={() => setActiveTab(null)}>
                    <div style={{ ...popupItem, color: '#4CAF50' }}>Aktív beírólap</div>
                  </Link>
                  <div style={{ ...dividerStyle, width: '100%', height: '1px', margin: '0' }} />
                </>
              )}
              <Link to="/qr-scanner" style={{ textDecoration: 'none' }} onClick={() => setActiveTab(null)}>
                <div style={popupItem}>QR-kód olvasás</div>
              </Link>
              <Link to="/versenyek" style={{ textDecoration: 'none' }} onClick={() => setActiveTab(null)}>
                <div style={popupItem}>Versenyek listája</div>
              </Link>
              <Link to="/eredmenyek" style={{ textDecoration: 'none' }} onClick={() => setActiveTab(null)}>
                <div style={popupItem}>Eredmények</div>
              </Link>
              <div style={arrowStyleRight} />
            </div>
          );
        })()}
      </div>
    </div>
  );
};

// --- STÍLUSOK ---
const navbarContainerStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  height: '60px',
  backgroundColor: '#eeeeee', // Fallback
  backgroundImage: 'linear-gradient(#eeeeee, #eeeeee)', // Golyóálló megoldás sötét mód ellen
  borderTop: '1px solid #ddd',
  display: 'flex',
  alignItems: 'center',
  zIndex: 2000,
  boxShadow: '0 -2px 10px rgba(0,0,0,0.05)',
  colorScheme: 'only light'
};

const dividerStyle = {
  width: '1px',
  height: '35px',
  backgroundColor: '#ddd'
};

const popupStyle = {
  position: 'absolute',
  bottom: '70px',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: '#fff',
  borderRadius: '12px',
  padding: '8px 0',
  width: '160px',
  boxShadow: '0 5px 15px rgba(0,0,0,0.15)',
  zIndex: 2100,
  animation: 'fadeInUp 0.2s ease-out',
  border: '1px solid #eee'
};

const popupStyleRight = {
  ...popupStyle,
  left: 'auto',
  right: '5px',
  transform: 'none',
  animation: 'fadeInUpRight 0.2s ease-out'
};

const popupItem = {
  padding: '12px 16px',
  color: '#b30000',
  fontSize: '13px',
  fontWeight: 'bold',
  cursor: 'pointer',
  borderBottom: '1px solid #eee',
  textAlign: 'center'
};

const arrowStyle = {
  position: 'absolute',
  bottom: '-10px',
  left: '50%',
  transform: 'translateX(-50%)',
  borderLeft: '10px solid transparent',
  borderRight: '10px solid transparent',
  borderTop: '10px solid #fff'
};

const arrowStyleRight = {
  ...arrowStyle,
  left: 'auto',
  right: '30px',
  transform: 'none',
};

// CSS Animációk
const styleSheet = document.createElement("style");
styleSheet.innerText = `
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateX(-50%) translateY(10px); }
    to { opacity: 1; transform: translateX(-50%) translateY(0); }
  }
  @keyframes fadeInUpRight {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;
document.head.appendChild(styleSheet);

export default BottomNavbar;
